export default {
  "cdnVersion": "6.68.0"
};